import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setShowSourcesPanel} from "../../../redux/slices/chat";
import {ResearchLink} from "../types";

const SourcesPanel = () => {
  const dispatch = useDispatch();
  const {
    researchLinks = [],
  } = useSelector((state: any) => state.chatMessages);

  const hideSourcesPanel = () => {
    dispatch(setShowSourcesPanel(false))
  }

  return (
    <div className="hidden md:flex flex-col rounded-l-xl absolute top-0 right-0 bottom-0 h-full w-[360px] border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg z-20">
      <div className="flex items-center flex-shrink-0 justify-between p-3 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">
            Sources
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            {researchLinks?.length || 0}
          </span>
        </div>
        <button
          onClick={hideSourcesPanel}
          className="px-2 py-1 rounded-md text-xs text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          title="Close"
        >
          Close
        </button>
      </div>
      <div className="flex-1 p-3 space-y-2 overflow-y-auto overflow-x-hidden">
        {researchLinks.map((s: ResearchLink, i: number) => (
          <a
            key={`${s.url}-${i}`}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 group"
            title={s.title}
          >
            <img src={s.favicon || `https://www.google.com/s2/favicons?domain=${s.host || ''}&sz=64`} alt="" className="w-4 h-4 rounded" />
            <div className="min-w-0 flex-1">
              <div className="text-xs text-gray-800 dark:text-gray-200 truncate">{s.title || s.host || s.url}</div>
              {s.host && <div className="text-[10px] text-gray-500 dark:text-gray-400 truncate">{s.host}</div>}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="text-gray-400 group-hover:text-gray-600" viewBox="0 0 16 16">
              <path d="M6.354 5.5H11.5a.5.5 0 0 1 0 1H7.707l5.147 5.146a.5.5 0 0 1-.708.708L7 7.207v3.793a.5.5 0 0 1-1 0V5.5a.5.5 0 0 1 .5-.5z"/>
            </svg>
          </a>
        ))}
      </div>
    </div>
  )
};

export default SourcesPanel;